/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoRegistryOfficeAddUsers } from '../../models/dto-registry-office-add-users';
import { RegistryOfficeItem } from '../../models/registry-office-item';

export interface OfficeControllerAddUsers$Params {
  idOffice: number;
      body: DtoRegistryOfficeAddUsers
}

export function officeControllerAddUsers(http: HttpClient, rootUrl: string, params: OfficeControllerAddUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeItem;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerAddUsers.PATH, 'patch');
  if (params) {
    rb.path('idOffice', params.idOffice, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: RegistryOfficeItem;
      }>;
    })
  );
}

officeControllerAddUsers.PATH = '/registry/office/{idOffice}/users';
